function clamp(value, min, max){
  if (value > max) value = max;
  else if  (value < min) value = min;
  return value;
}

export function lightenDarken({r, g, b}, amt) {
  r = clamp(r + amt, 0, 255);
  g = clamp(g + amt, 0, 255);
  b = clamp(b + amt, 0, 255);
  return {r, g, b};
}
